import { ColumnConfig } from '@/components/table/Table';
import { extractDate, formatDate } from '@/utils/dates';
import { Link } from 'react-router-dom';
import { TransitControlItem } from '../models';

export const transitControlTableColumns: ColumnConfig[] = [
  {
    label: 'Número interno',
    field: 'number',
    sortable: true,
    render: (value: string | number) => {
      const numberText = String(value ?? '').trim();
      if (!numberText) return '______';
      return (
        <Link
          to={`/business/shipping/${numberText}`}
          onClick={(event) => event.stopPropagation()}
          className='font-semibold text-[#1976d2] hover:text-[#1565c0] tabular-nums focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1976d2] focus-visible:ring-offset-1 rounded'
        >
          {numberText}
        </Link>
      );
    },
  },
  {
    label: 'Número externo',
    field: 'commerceShippingNumber',
    render: (_value: string | null, rowData: TransitControlItem) =>
      rowData.commerceShippingNumber ||
      rowData.logisticOperatorShippingNumber ||
      '______',
  },
  {
    label: 'Comercio',
    field: 'commerceName',
    sortable: true,
    render: (value: string | null) => value || '______',
  },
  {
    label: 'Fecha de ingreso',
    field: 'createdAt',
    sortable: true,
    render: (value: string) => extractDate(value),
  },
  {
    label: 'ETA',
    field: 'dateToDelivery',
    sortable: true,
    render: (value: string | null) => extractDate(value),
  },
  {
    label: 'Estado actual',
    field: 'statusCommercialName',
    sortable: true,
    render: (_value: string | null, rowData: TransitControlItem) =>
      rowData.statusCommercialName || rowData.statusName || '______',
  },
  {
    label: 'Fecha del estado actual',
    field: 'eventDt',
    sortable: true,
    render: (value: string | null) => formatDate(value),
  },
];
